<div class="tt-offline-guidelines-table_filter">
  <input ttInput [placeholder]="'Search' | transloco" [(ngModel)]="searchTerm" (ngModelChange)="offlineGuidelinesTableStore.loadPage()" />
</div>

<div class="tt-offline-guidelines-table_container">
  <mat-table class="tt-offline-guidelines-table_table" matSort [dataSource]="dataSource()" (matSortChange)="handleSort($event)">
    <ng-container [matColumnDef]="OfflineTableColumnName.Title">
      <mat-header-cell *matHeaderCellDef class="header" mat-sort-header>{{ 'Title' | transloco }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="cell title" [attr.data-testid]="'guidelines-table_cell-title-' + element.uniqueId">
        {{ element.title }}
      </mat-cell>
    </ng-container>

    <ng-container [matColumnDef]="OfflineTableColumnName.Version">
      <mat-header-cell *matHeaderCellDef class="header hideForMobile">{{ 'Version' | transloco }}</mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        class="cell hideForMobile"
        [attr.data-testid]="'guidelines-table_cell-version-' + element.uniqueId">
        <span>{{ element.version }}</span>
      </mat-cell>
    </ng-container>

    <ng-container [matColumnDef]="OfflineTableColumnName.Owner">
      <mat-header-cell *matHeaderCellDef class="header hideForMobile">{{ 'GuidelineOwner' | transloco }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="cell hideForMobile" [attr.data-testid]="'guidelines-table_cell-owner-' + element.uniqueId">
        <span>{{ element.owner | name }}</span>
      </mat-cell>
    </ng-container>

    <ng-container [matColumnDef]="OfflineTableColumnName.Publisher">
      <mat-header-cell *matHeaderCellDef class="header hideForMobile">{{ 'Publisher' | transloco }}</mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        class="cell hideForMobile"
        [attr.data-testid]="'guidelines-table_cell-publisher-' + element.uniqueId">
        <span>{{ element.publisher | name }}</span>
      </mat-cell>
    </ng-container>

    <ng-container [matColumnDef]="OfflineTableColumnName.PublishedAt">
      <mat-header-cell *matHeaderCellDef class="header hideForMobile" mat-sort-header>{{ 'PublishedOn' | transloco }}</mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        class="cell hideForMobile"
        [attr.data-testid]="'guidelines-table_cell-published-at-' + element.uniqueId">
        {{ element.publishedAt | addZToUTC | translocoDate }}
      </mat-cell>
    </ng-container>

    <ng-container *matNoDataRow>
      @if (!!searchTerm()) {
        <tt-no-results
          [actionLabel]="'Offline.OfflineSmartbook.NoResults.ClearSearch'"
          [message]="'Offline.OfflineSmartbook.NoResults.FilteredDescription'"
          [title]="'NoGuidelinesFound.Heading'"
          (actionClicked)="handleClearFilter()" />
      } @else {
        <tt-no-results [message]="'Offline.OfflineSmartbook.NoResults.Description'" [title]="'NoGuidelinesExist.Heading'" />
      }
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns" class="header" />
    <mat-row *matRowDef="let row; columns: displayedColumns" class="row" (click)="onOpenGuideline(row.uniqueId)" />
  </mat-table>

  <tt-paginator
    [itemsPerPage]="vm().paging.itemsPerPage"
    [maxElements]="vm().paging.maxElements"
    [page]="vm().paging.page"
    [pageSizeOptions]="[5, 10, 25, 100]"
    (pageEvent)="handlePageEvent($event)" />
</div>
